import React from 'react';
import TatvarSuuriGuilgeeBalance from './tatvarSuuriGuilgeeBalance';

const PageList = () => <TatvarSuuriGuilgeeBalance />;

export default PageList;
